module.exports = __webpack_public_path__ + "static/media/163-papua-new-guinea.505f7d56.svg";